<template>
  <div>
    <b-row>
      <b-col>
        <h3>Pedido</h3>
      </b-col>
    </b-row>
  </div>
</template>

<script>

  export default {
    components: {
    }
  }
</script>
